import { render } from "./CookiesDialog.vue?vue&type=template&id=aff5ac6c&ts=true"
import script from "./CookiesDialog.vue?vue&type=script&lang=ts"
export * from "./CookiesDialog.vue?vue&type=script&lang=ts"

import "./CookiesDialog.vue?vue&type=style&index=0&id=aff5ac6c&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__